import * as Yup from 'yup'
import createUsecaseFormModel from './createUsecaseFormModel'

const {
    formField: {
        name,
        max_duration,
        environment_config_id,
        main_area_name,
        main_area_lat,
        main_area_lon,
        areas_array,
        payload_assets_array,
        platform_assets_array,
        threats_array,
    },
} = createUsecaseFormModel

const latitude_generic_validation = Yup.number()
    .required('Latitude value is required')
    .min(-90, 'Latitude must be higher or equal than -90')
    .max(90, 'Latitude must be lower or equal than 90')

const longitude_generic_validation = Yup.number()
    .required('Longitude value is required')
    .min(-180, 'Longitude must be higher or equal than -180')
    .max(180, 'Longitude must be lower or equal than 180')

const altitude_generic_validation = Yup.number().required('Altitude value is required')

// const velocity_generic_validation = Yup.number().required('Velocity value is required').min(0, 'Velocity must be higher or equal than 0')

export default [
    // GENERAL FORM VALIDATION
    Yup.object().shape({
        [name.name]: Yup.string().required(`${name.requiredErrorMsg}`),
        [max_duration.name]: Yup.number().test(
            'Is positive?',
            'The number must be greater or equal than 0!',
            (value) => value! > -1 || value == null,
        ),
        [environment_config_id.name]: Yup.number().test(
            'Is positive?',
            'The number must be greater than 0!',
            (value) => value! > 0 || value == null,
        ),
    }),
    // SITUATION FORM VALIDATION
    Yup.object().shape({
        [main_area_name.name]: Yup.string().required(`${main_area_name.requiredErrorMsg}`),
        [main_area_lat.name]: Yup.number()
            .required(`${main_area_lat.requiredErrorMsg}`)
            .min(-90, `${main_area_lat.rangeErrorMsg}`)
            .max(90, `${main_area_lat.rangeErrorMsg}`),
        [main_area_lon.name]: Yup.number()
            .required(`${main_area_lon.requiredErrorMsg}`)
            .min(-180, `${main_area_lat.rangeErrorMsg}`)
            .max(180, `${main_area_lat.rangeErrorMsg}`),
        [areas_array.name]: Yup.array().of(
            Yup.object().shape({
                name: Yup.string().required(`${areas_array.fields.name.requiredErrorMsg}`),
                type: Yup.string().required(`${areas_array.fields.type.requiredErrorMsg}`),
                polygon: Yup.array().of(
                    Yup.object().shape({
                        lat: latitude_generic_validation,
                        lon: longitude_generic_validation,
                    }),
                ),
            }),
        ),
    }),
    // ASSETS FORM VALIDATION
    Yup.object().shape({
        [payload_assets_array.name]: Yup.array().of(
            Yup.object().shape({
                name: Yup.string().required(`${payload_assets_array.fields.name.requiredErrorMsg}`),
                type: Yup.string().required(`${payload_assets_array.fields.type.requiredErrorMsg}`),
                model: Yup.string().required(`${payload_assets_array.fields.model.requiredErrorMsg}`),
                position: Yup.object().shape({
                    lat: Yup.number()
                        .min(-90, 'Latitude must be higher or equal than -90')
                        .max(90, 'Latitude must be lower or equal than 90'),
                    lon: Yup.number()
                        .min(-180, 'Longitude must be higher or equal than -180')
                        .max(180, 'Longitude must be lower or equal than 180'),
                    alt: Yup.number(),
                }),
            }),
        ),
        [platform_assets_array.name]: Yup.array().of(
            Yup.object().shape({
                name: Yup.string().required(`${platform_assets_array.fields.name.requiredErrorMsg}`),
                type: Yup.string().required(`${platform_assets_array.fields.type.requiredErrorMsg}`),
                model: Yup.string().required(`${platform_assets_array.fields.model.requiredErrorMsg}`),
                position: Yup.object().shape({
                    lat: latitude_generic_validation,
                    lon: longitude_generic_validation,
                    alt: altitude_generic_validation,
                }),
                sparq_id: Yup.string(),
            }),
        ),
    }),
    // THREATS FORM VALIATION
    Yup.object().shape({
        [threats_array.name]: Yup.array().of(
            Yup.object().shape({
                name: Yup.string().required(`${threats_array.fields.name.requiredErrorMsg}`),
                type: Yup.string().required(`${threats_array.fields.type.requiredErrorMsg}`),
                model: Yup.string().required(`${threats_array.fields.model.requiredErrorMsg}`),
                initial_position: Yup.object().shape({
                    lat: latitude_generic_validation,
                    lon: longitude_generic_validation,
                    alt: altitude_generic_validation,
                }),
                waypoints: Yup.array().of(
                    Yup.object().shape({
                        lat: Yup.number()
                            .min(-90, 'Latitude must be higher or equal than -90')
                            .max(90, 'Latitude must be lower or equal than 90'),
                        lon: Yup.number()
                            .min(-180, 'Longitude must be higher or equal than -180')
                            .max(180, 'Longitude must be lower or equal than 180'),
                        alt: Yup.number(),
                        vel: Yup.number().min(0, 'Velocity must be higher or equal than 0'),
                    }),
                ),
                sparq_id: Yup.string(),
                alliance: Yup.string().required(`${threats_array.fields.alliance.requiredErrorMsg}`),
            }),
        ),
    }),
]
